import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Brand colors (matches theme: navy primary, gold secondary).
const NAVY = '#1a365d';
const GOLD = '#d4af37';

// Custom teardrop pin marker built with an inline SVG divIcon.
const createPinIcon = () =>
  L.divIcon({
    className: 'chato-map-pin',
    html: `
      <svg width="34" height="46" viewBox="0 0 34 46" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="pinShadow" x="-30%" y="-10%" width="160%" height="140%">
            <feDropShadow dx="0" dy="2" stdDeviation="2.2" flood-color="rgba(0,0,0,0.35)"/>
          </filter>
        </defs>
        <path filter="url(#pinShadow)" fill="${NAVY}" stroke="${GOLD}" stroke-width="2"
          d="M17 1C9.3 1 3 7.2 3 15c0 9.6 12.1 27 13.2 28.5a1 1 0 0 0 1.6 0C18.9 42 31 24.6 31 15 31 7.2 24.7 1 17 1z"/>
        <circle cx="17" cy="15" r="5.4" fill="${GOLD}"/>
      </svg>
    `,
    iconSize: [34, 46],
    iconAnchor: [17, 45],
    popupAnchor: [0, -40],
    tooltipAnchor: [0, -38],
  });

const pinIcon = createPinIcon();

// Central Coast cities served, San Luis Obispo down to Santa Barbara.
const cities = [
  { name: 'San Luis Obispo', position: [35.2828, -120.6596] },
  { name: 'Pismo Beach', position: [35.1428, -120.6413] },
  { name: 'Santa Maria', position: [34.9530, -120.4357] },
  { name: 'Lompoc', position: [34.6391, -120.4579] },
  { name: 'Santa Barbara', position: [34.4208, -119.6982] },
];

// Center roughly between SLO and Santa Barbara.
const center = [34.85, -120.2];

const ServiceAreaMap = () => {
  return (
    <>
      {/* Scoped styling for popups/tooltips so they match the brand. */}
      <style>{`
        .leaflet-container { font-family: inherit; }
        .chato-map-pin { background: transparent; border: none; }
        .leaflet-popup-content-wrapper {
          border-radius: 10px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.18);
          border-top: 3px solid ${GOLD};
        }
        .leaflet-popup-content { margin: 12px 16px; }
        .chato-popup-title {
          font-weight: 700; color: ${NAVY}; font-size: 15px; margin: 0 0 2px;
        }
        .chato-popup-sub {
          color: #64748b; font-size: 12px; margin: 0;
        }
        .chato-tooltip {
          background: ${NAVY}; color: #fff; border: none;
          font-weight: 600; font-size: 12px; padding: 4px 9px; border-radius: 6px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.25);
        }
        .chato-tooltip::before { border-top-color: ${NAVY}; }
      `}</style>
      <MapContainer
        center={center}
        zoom={9}
        scrollWheelZoom={false}
        style={{ height: '460px', width: '100%', borderRadius: '12px' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {cities.map((city) => (
          <React.Fragment key={city.name}>
            <Circle
              center={city.position}
              radius={9000}
              pathOptions={{
                color: GOLD,
                weight: 1.5,
                fillColor: GOLD,
                fillOpacity: 0.12,
              }}
            />
            <Marker position={city.position} icon={pinIcon}>
              <Tooltip className="chato-tooltip" direction="top" offset={[0, -38]}>
                {city.name}
              </Tooltip>
              <Popup>
                <p className="chato-popup-title">{city.name}</p>
                <p className="chato-popup-sub">Service area &bull; Chato Home Services</p>
              </Popup>
            </Marker>
          </React.Fragment>
        ))}
      </MapContainer>
    </>
  );
};

export default ServiceAreaMap;
